import classNames from 'classnames'

import { Text } from '@/shared/components/typography'
import type { TextProps } from '@/shared/components/typography/Title'

interface CoverFooterProps {
  buttonText: string
  onClick: () => void
  isDisabled?: boolean
  bgColor?: React.HTMLAttributes<HTMLButtonElement>['className']
  textColor?: TextProps['color']
  children?: React.ReactNode
  wrapperStyle?: React.HTMLAttributes<HTMLDivElement>['className']
  disabledBtnColor?: React.HTMLAttributes<HTMLButtonElement>['className']
}

const ProcessFooter = ({
  buttonText,
  onClick,
  isDisabled = false,
  bgColor = 'bg-main-050',
  textColor = 'text010',
  children,
  wrapperStyle,
  disabledBtnColor = 'disabled:bg-gray-020'
}: CoverFooterProps) => {
  return (
    <div className={classNames(`w-full pb-3`, wrapperStyle)}>
      <div className="w-full px-4">
        {children}
        <button
          disabled={isDisabled}
          onClick={onClick}
          className={classNames(
            `sticky bottom-0 flex h-[56px] w-full items-center justify-between rounded-[6px] bg-010 px-4 py-[15px] transition duration-200 hover:brightness-90 disabled:cursor-not-allowed ${disabledBtnColor} disabled:hover:brightness-100`,
            [bgColor]
          )}
        >
          <Text level="text2" color={isDisabled ? 'text050' : textColor} className={'w-full text-center'}>
            {buttonText}
          </Text>
        </button>
      </div>
    </div>
  )
}

export default ProcessFooter
